export default {
  paged: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    expand: {
      parentProcessGroup: { select: 'name' },
    },
  },
  item: {
    select: 'id,name,description,isActive',
    expand: {
      parentProcessGroup: { select: 'id,name' },
    },
  },
  itemDetail: {
    select: 'id,name,description,isActive,created,updated',
    expand: {
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
      parentProcessGroup: { select: 'id,name' },
    },
  },
};
